var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCoin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f9h16d050a",
  x1: 0.912,
  y1: 0.667,
  x2: -0.318,
  y2: 0.167,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc64f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.277,
  stopColor: "#e06919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.707,
  stopColor: "#ffc640"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa02b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "78hqkqh0qb",
  x1: 0.168,
  y1: 0.817,
  x2: 1.029,
  y2: -0.006,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "kub8b7q3oc",
  x1: 0.769,
  y1: 0.15,
  x2: -0.327,
  y2: 1.575,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e06919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa02b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mxby0ihphd",
  x1: 0.728,
  y1: 0.132,
  x2: -0.176,
  y2: 1.05,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#941010"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa02b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "xzihsspmye",
  x1: 0.142,
  y1: 1.041,
  x2: 0.878,
  y2: -0.072,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1xhq1wxd8f",
  x1: 0.171,
  y1: 0.739,
  x2: 0.816,
  y2: -0.029,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "kllaahhwog",
  x1: 0.866,
  y1: 0.182,
  x2: 0.211,
  y2: 0.89,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cmcehee6uh",
  x1: 0.6,
  y1: 0.343,
  x2: 0.219,
  y2: 0.878,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grygmw0qei",
  x1: 1.207,
  y1: 0.061,
  x2: -0.048,
  y2: 0.841,
  xlinkHref: "#f9h16d050a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rv165g1ufj",
  x1: 0.13,
  y1: 1.06,
  x2: 0.844,
  y2: 0.081,
  xlinkHref: "#f9h16d050a"
}))), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 207",
  style: {
    fill: "none"
  },
  d: "M0 0h22v22H0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 107",
  d: "M36.564 51.977h-9.927a.073.073 0 0 0-.063.037l-4.963 8.6a.073.073 0 0 0 0 .073l4.963 8.6a.073.073 0 0 0 .063.037h9.927a.073.073 0 0 0 .063-.037l4.963-8.6a.073.073 0 0 0 0-.073l-4.963-8.6a.073.073 0 0 0-.064-.037z",
  transform: "translate(-20.602 -49.647)",
  style: {
    fill: "url(#f9h16d050a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 108",
  d: "M44.071 58.941h-9.577a.071.071 0 0 0-.061.035l-4.789 8.294a.071.071 0 0 0 0 .071l4.789 8.294a.071.071 0 0 0 .061.035h9.578a.071.071 0 0 0 .061-.035l4.789-8.294a.071.071 0 0 0 0-.071l-4.789-8.294a.071.071 0 0 0-.062-.035z",
  transform: "translate(-28.284 -56.306)",
  style: {
    fill: "url(#78hqkqh0qb)"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 109",
  d: "M47.028 83.491h-8.506a1 1 0 0 1-.865-.5L33.4 75.625a1 1 0 0 1 0-1l3.985-6.9a.981.981 0 0 0-.088.115l-4.253 7.366a1 1 0 0 0 0 1L37.3 83.57a1 1 0 0 0 .865.5h8.506a1 1 0 0 0 .865-.5l.268-.464a.992.992 0 0 1-.776.385z",
  transform: "translate(-31.42 -64.705)",
  style: {
    fill: "#c20000",
    opacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 110",
  d: "m145.763 66.806-4.253-7.366a1 1 0 0 0-.865-.5h-8.506a1 1 0 0 0-.865.5l-.084.145a.991.991 0 0 1 .592-.205h8.506a1 1 0 0 1 .865.5l4.253 7.366a1 1 0 0 1 0 1l-4.169 7.221a.987.987 0 0 0 .273-.294l4.253-7.366a1 1 0 0 0 0-1.001z",
  transform: "translate(-125.393 -56.305)",
  style: {
    opacity: 0.3,
    fill: "#ffeea2"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 111",
  d: "M84.073 96.054h-7.717a.057.057 0 0 0-.049.029l-3.859 6.683a.057.057 0 0 0 0 .057l3.859 6.683a.057.057 0 0 0 .049.028h7.717a.057.057 0 0 0 .049-.028l3.859-6.683a.057.057 0 0 0 0-.057l-3.859-6.683a.057.057 0 0 0-.049-.029z",
  transform: "translate(-69.215 -91.794)",
  style: {
    fill: "url(#kub8b7q3oc)"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 112",
  d: "m166.857 102.393-3.427-5.935a.8.8 0 0 0-.7-.4h-6.85a.8.8 0 0 0-.7.4l-.029.05a.8.8 0 0 1 .686-.388h6.854a.8.8 0 0 1 .7.4l3.427 5.935a.8.8 0 0 1 0 .8l-3.4 5.885c0-.005.008-.009.011-.015l3.427-5.935a.8.8 0 0 0 .001-.797z",
  transform: "translate(-148.308 -91.795)",
  style: {
    fill: "url(#mxby0ihphd)",
    opacity: 0.3
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 113",
  d: "M88.519 100.179h-7.51a.055.055 0 0 0-.048.028l-3.755 6.5a.056.056 0 0 0 0 .055l3.755 6.5a.056.056 0 0 0 .048.028h7.51a.056.056 0 0 0 .048-.028l3.755-6.5a.056.056 0 0 0 0-.055l-3.755-6.5a.055.055 0 0 0-.048-.028z",
  transform: "translate(-73.765 -95.738)",
  style: {
    fill: "url(#xzihsspmye)"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 114",
  d: "M90.884 119.578h-6.67a.783.783 0 0 1-.678-.392L80.2 113.41a.783.783 0 0 1 0-.783l3.068-5.313a.765.765 0 0 0-.061.079l-3.335 5.776a.783.783 0 0 0 0 .783l3.335 5.776a.783.783 0 0 0 .678.392h6.67a.783.783 0 0 0 .678-.392l.267-.463a.778.778 0 0 1-.616.313z",
  transform: "translate(-76.222 -102.56)",
  style: {
    fill: "#ffdd45",
    opacity: 0.3
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 115",
  d: "m162.275 106.345-3.335-5.776a.783.783 0 0 0-.678-.392h-6.67a.783.783 0 0 0-.678.392l-.34.589a.782.782 0 0 1 .395-.107h6.67a.783.783 0 0 1 .678.392l3.335 5.776a.783.783 0 0 1 0 .783l-3 5.188a.782.782 0 0 0 .284-.285l3.335-5.776a.784.784 0 0 0 .004-.784z",
  transform: "translate(-143.928 -95.737)",
  style: {
    fill: "url(#1xhq1wxd8f)",
    opacity: 0.3
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 116",
  d: "m141.456 154.442 1.565 1.91a.509.509 0 0 0 .208.151l2.3.9a.508.508 0 0 1 .243.748l-1.333 2.079a.508.508 0 0 0-.08.245l-.143 2.466a.508.508 0 0 1-.636.462l-2.389-.625a.509.509 0 0 0-.257 0l-2.389.625a.508.508 0 0 1-.636-.462l-.143-2.466a.508.508 0 0 0-.08-.245l-1.333-2.079a.508.508 0 0 1 .243-.748l2.3-.9a.509.509 0 0 0 .208-.151l1.565-1.91a.508.508 0 0 1 .787 0z",
  transform: "translate(-130.253 -147.448)",
  style: {
    opacity: 0.2,
    fill: "#ba0000"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 117",
  d: "m144.385 149.423 1.565 1.91a.507.507 0 0 0 .208.151l2.3.9a.508.508 0 0 1 .243.748l-1.333 2.079a.509.509 0 0 0-.08.245l-.143 2.466a.508.508 0 0 1-.636.462l-2.389-.626a.509.509 0 0 0-.257 0l-2.389.626a.508.508 0 0 1-.636-.462l-.143-2.466a.508.508 0 0 0-.08-.245l-1.333-2.079a.508.508 0 0 1 .243-.748l2.3-.9a.509.509 0 0 0 .208-.151l1.565-1.91a.508.508 0 0 1 .787 0z",
  transform: "translate(-133.054 -142.649)",
  style: {
    opacity: 0.2,
    fill: "#ba0000"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 118",
  d: "m145.222 145.45 1.565 1.91a.509.509 0 0 0 .208.151l2.3.9a.508.508 0 0 1 .243.748l-1.333 2.079a.508.508 0 0 0-.08.245l-.143 2.466a.508.508 0 0 1-.636.462l-2.389-.625a.509.509 0 0 0-.257 0l-2.389.625a.508.508 0 0 1-.636-.462l-.143-2.466a.508.508 0 0 0-.08-.245l-1.333-2.079a.508.508 0 0 1 .243-.748l2.3-.9a.509.509 0 0 0 .208-.151l1.565-1.91a.508.508 0 0 1 .787 0z",
  transform: "translate(-133.854 -138.85)",
  style: {
    fill: "url(#kllaahhwog)"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 224",
  style: {
    opacity: 0.3
  }
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 119",
  d: "M319.1 283.756a.508.508 0 0 0-.079.245l-.143 2.465a.474.474 0 0 1-.029.1.49.49 0 0 0 .116-.277l.143-2.466a.506.506 0 0 1 .051-.158z",
  transform: "translate(-304.838 -271.19)",
  style: {
    fill: "#ffd069"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 120",
  d: "m149.765 148.41-2.3-.9a.509.509 0 0 1-.208-.151l-1.565-1.91a.508.508 0 0 0-.786 0l-1.565 1.91a.509.509 0 0 1-.208.151l-2.3.9a.5.5 0 0 0-.3.352.492.492 0 0 1 .215-.174l2.3-.9a.509.509 0 0 0 .208-.151l1.565-1.91a.508.508 0 0 1 .786 0l1.565 1.91a.508.508 0 0 0 .208.151l2.3.9a.5.5 0 0 1 .278.65l.052-.081a.508.508 0 0 0-.245-.747z",
  transform: "translate(-134.323 -138.85)",
  style: {
    fill: "#ffd069"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 225",
  style: {
    opacity: 0.4
  }
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 121",
  d: "m147.515 226.545-2.389-.626a.509.509 0 0 0-.257 0l-2.389.626a.508.508 0 0 1-.636-.462l-.143-2.466a.508.508 0 0 0-.08-.245l-1.333-2.079a.491.491 0 0 1-.071-.275.5.5 0 0 0-.03.577l1.333 2.079a.509.509 0 0 1 .08.245l.143 2.466a.508.508 0 0 0 .636.462l2.389-.625a.509.509 0 0 1 .257 0l2.389.625a.508.508 0 0 0 .636-.462v-.045a.5.5 0 0 1-.535.205z",
  transform: "translate(-133.922 -211.288)",
  style: {
    fill: "url(#cmcehee6uh)"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 122",
  d: "M327.116 230.329a.509.509 0 0 0-.08.245v.027l1.314-2.048a.491.491 0 0 0 .073-.258z",
  transform: "translate(-312.664 -218.244)",
  style: {
    fill: "url(#grygmw0qei)"
  }
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 123",
  d: "m159.506 164.983 1.314 1.6a.426.426 0 0 0 .175.127l1.931.754a.427.427 0 0 1 .2.628l-1.119 1.745a.426.426 0 0 0-.067.206l-.12 2.07a.427.427 0 0 1-.534.388l-2.006-.525a.427.427 0 0 0-.216 0l-2.006.525a.427.427 0 0 1-.534-.388l-.12-2.07a.427.427 0 0 0-.067-.206l-1.119-1.745a.427.427 0 0 1 .2-.628l1.932-.754a.427.427 0 0 0 .175-.127l1.314-1.6a.427.427 0 0 1 .667 0z",
  transform: "translate(-148.307 -157.556)",
  style: {
    fill: "#f53700",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 124",
  d: "m161.943 162.206 1.314 1.6a.427.427 0 0 0 .175.127l1.931.754a.427.427 0 0 1 .2.628l-1.119 1.745a.426.426 0 0 0-.067.206l-.12 2.07a.427.427 0 0 1-.534.388l-2.006-.525a.426.426 0 0 0-.216 0l-2.006.525a.427.427 0 0 1-.534-.388l-.12-2.07a.427.427 0 0 0-.067-.206l-1.119-1.745a.427.427 0 0 1 .2-.628l1.931-.754a.427.427 0 0 0 .175-.127l1.314-1.6a.427.427 0 0 1 .668 0z",
  transform: "translate(-150.638 -154.9)",
  style: {
    fill: "url(#rv165g1ufj)"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 226",
  style: {
    opacity: 0.3
  }
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 125",
  d: "M308.173 279.1a.428.428 0 0 0-.067.206l-.12 2.07a.4.4 0 0 1-.018.06.413.413 0 0 0 .086-.221l.12-2.07a.421.421 0 0 1 .032-.1z",
  transform: "translate(-294.431 -266.773)",
  style: {
    fill: "#ffe98b"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 126",
  d: "m165.711 164.69-1.931-.754a.426.426 0 0 1-.175-.127l-1.314-1.6a.427.427 0 0 0-.66 0l-1.314 1.6a.427.427 0 0 1-.175.127l-1.931.754a.417.417 0 0 0-.256.317.412.412 0 0 1 .187-.157l1.931-.754a.426.426 0 0 0 .175-.127l1.314-1.6a.427.427 0 0 1 .66 0l1.314 1.6a.427.427 0 0 0 .175.127l1.932.754a.42.42 0 0 1 .247.507l.025-.039a.427.427 0 0 0-.2-.628z",
  transform: "translate(-150.985 -154.9)",
  style: {
    fill: "#ffe98b"
  }
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 127",
  d: "m138.079 60.128-4.408-7.635a1.035 1.035 0 0 0-.9-.518h-8.816a1.035 1.035 0 0 0-.9.518l-.265.459L133.23 69.2a1.028 1.028 0 0 0 .441-.4l4.408-7.635a1.035 1.035 0 0 0 0-1.035z",
  transform: "translate(-117.368 -49.646)",
  style: {
    opacity: 0.2,
    fill: "#ffdd45"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8006a2a9f2248b6df66e434d2929b48e.svg";